<dx-popup
    title="Ton Expense"
    [width]="300"
    [height]="'auto'"
    [(visible)]="visible"
    [hideOnOutsideClick]="false"
    (onHiding)="onHiding($event)"
>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    <dx-form [formData]="tonExpense" class="mb-4" validationGroup="mainValidationGroup">
        <dxi-form-item dataField="name">
            <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
        </dxi-form-item>
        <dxi-form-item dataField="amount">
            <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
        </dxi-form-item>
    </dx-form>
</dx-popup>
